import ResponsiveAlert from "./ResponsiveAlert";

export default ResponsiveAlert;
